import * as React from 'react';

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, basedir, module) {
	return module = {
	  path: basedir,
	  exports: {},
	  require: function (path, base) {
      return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
    }
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var _typeof_1 = createCommonjsModule(function (module) {
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _typeof(obj);
}

module.exports = _typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _typeof = /*@__PURE__*/unwrapExports(_typeof_1);

var dispatchNotification = function dispatchNotification(_a) {
  var title = _a.title,
      message = _a.message,
      timeout = _a.timeout,
      onClick = _a.onClick,
      onShow = _a.onShow,
      onError = _a.onError,
      onClose = _a.onClose,
      applicationIconPath = _a.applicationIconPath,
      additionalTag = _a.additionalTag;

  var _b = React.useState(false),
      hasAccess = _b[0],
      determineUsage = _b[1];

  var time;

  if (typeof timeout === 'number') {
    time = timeout;
  } else if (typeof timeout === 'string') {
    if (timeout.endsWith('s')) {
      time = parseInt(timeout.replace('s', ''), 2) * 1000;
    } else if (timeout.endsWith('m')) {
      time = parseInt(timeout.replace('m', ''), 2) * 60 * 1000;
    } else {
      console.warn("O campo timeout deve ser do tipo string ou number, por\xE9m est\xE1 recebendo o tipo " + _typeof(timeout));
    }
  }

  React.useEffect(function () {
    if (window) {
      if (!('Notification' in window)) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn('Esse navegador suporta o uso de notificações. Logo, não será possível utilizar o hook dispatchNotification.');
        }
      } else if (Notification.permission === 'granted') {
        determineUsage(true);
      } else {
        Notification.requestPermission().then(function (permission) {
          if (permission && permission === 'granted') {
            determineUsage(true);
          }
        });
      }
    }
  }, []);
  React.useEffect(function () {
    if (hasAccess) {
      var options = {
        lang: 'pt-BR'
      };

      if (message) {
        options.body = message;
      }

      if (additionalTag) {
        options.tag = additionalTag;
      }

      if (applicationIconPath) {
        if (applicationIconPath.endsWith('.jpg') || applicationIconPath.endsWith('.svg') || applicationIconPath.endsWith('.png')) {
          options.icon = applicationIconPath;
        }
      }

      var notification_1 = new Notification(title, options);

      if (typeof onClick === 'function') {
        notification_1.onclick = onClick;
      }

      if (typeof onShow === 'function') {
        notification_1.onshow = onShow;
      }

      if (typeof onError === 'function') {
        notification_1.onerror = onError;
      }

      if (typeof onClose === 'function') {
        notification_1.onclose = onClose;
      }

      setTimeout(function () {
        notification_1.close.bind(notification_1);
      }, time);
    }
  }, [hasAccess]);
  return hasAccess;
};

/* global DocumentEventMap */

var useClickAway = function useClickAway(onClick, ref) {
  var dispatcher = React.useRef(onClick);

  var _handleMouseDown = function _handleMouseDown(event) {
    if (dispatcher && dispatcher.current) {
      if (typeof dispatcher.current === 'function') {
        dispatcher.current(event);
      }
    }
  };

  var _handleTouchStart = function _handleTouchStart(event) {
    if (dispatcher && dispatcher.current) {
      if (typeof dispatcher.current === 'function') {
        dispatcher.current(event);
      }
    }
  };

  React.useEffect(function () {
    if (dispatcher && dispatcher.current) {
      if (dispatcher.current !== onClick) {
        dispatcher.current = onClick;
      }
    }
  }, [onClick]);
  React.useEffect(function () {
    document.addEventListener('mousedown', _handleMouseDown);
    document.addEventListener('touchstart', _handleTouchStart);
    return function () {
      document.removeEventListener('mousedown', _handleMouseDown);
      document.removeEventListener('touchstart', _handleTouchStart);
    };
  }, [ref]);
};

var toggleSelection = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;

  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' &&
    selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function(range) {
        selection.addRange(range);
      });
    }

    active &&
    active.focus();
  };
};

var clipboardToIE11Formatting = {
  "text/plain": "Text",
  "text/html": "Url",
  "default": "Text"
};

var defaultMessage = "Copy to clipboard: #{key}, Enter";

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug,
    message,
    reselectPrevious,
    range,
    selection,
    mark,
    success = false;
  if (!options) {
    options = {};
  }
  debug = options.debug || false;
  try {
    reselectPrevious = toggleSelection();

    range = document.createRange();
    selection = document.getSelection();

    mark = document.createElement("span");
    mark.textContent = text;
    // reset user styles for span element
    mark.style.all = "unset";
    // prevents scrolling to the end of the page
    mark.style.position = "fixed";
    mark.style.top = 0;
    mark.style.clip = "rect(0, 0, 0, 0)";
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = "pre";
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = "text";
    mark.style.MozUserSelect = "text";
    mark.style.msUserSelect = "text";
    mark.style.userSelect = "text";
    mark.addEventListener("copy", function(e) {
      e.stopPropagation();
      if (options.format) {
        e.preventDefault();
        if (typeof e.clipboardData === "undefined") { // IE 11
          debug && console.warn("unable to use e.clipboardData");
          debug && console.warn("trying IE specific stuff");
          window.clipboardData.clearData();
          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"];
          window.clipboardData.setData(format, text);
        } else { // all other browsers
          e.clipboardData.clearData();
          e.clipboardData.setData(options.format, text);
        }
      }
      if (options.onCopy) {
        e.preventDefault();
        options.onCopy(e.clipboardData);
      }
    });

    document.body.appendChild(mark);

    range.selectNodeContents(mark);
    selection.addRange(range);

    var successful = document.execCommand("copy");
    if (!successful) {
      throw new Error("copy command was unsuccessful");
    }
    success = true;
  } catch (err) {
    debug && console.error("unable to copy using execCommand: ", err);
    debug && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(options.format || "text", text);
      options.onCopy && options.onCopy(window.clipboardData);
      success = true;
    } catch (err) {
      debug && console.error("unable to copy using clipboardData: ", err);
      debug && console.error("falling back to prompt");
      message = format("message" in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == "function") {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }

  return success;
}

var copyToClipboard = copy;

var useClipboard = function useClipboard(timeout) {
  var _a = React.useState(),
      current = _a[0],
      copyIntoState = _a[1];

  var dispatchCopy = React.useCallback(function (value) {
    if (typeof value !== 'undefined') {
      if (typeof value === 'string') {
        copyToClipboard(value);
        copyIntoState(value);
      } else if (typeof value === 'number') {
        copyToClipboard(value.toString());
        copyIntoState(value);
      } else {
        if (typeof current !== 'undefined') {
          copyIntoState(undefined);
        }

        if (process.env.NODE_ENV !== 'production') {
          console.warn("N\xE3o foi poss\xEDvel copiar (via useClipboard) " + "o valor recebido pois tal valor \xE9 do tipo " + ("" + _typeof(value)));
        }
      }
    }
  }, []);
  React.useEffect(function () {
    var time;

    if (typeof timeout === 'number') {
      time = timeout;
    } else if (typeof timeout === 'string') {
      if (timeout.endsWith('s')) {
        time = parseInt(timeout.replace('s', ''), 2) * 1000;
      } else if (timeout.endsWith('m')) {
        time = parseInt(timeout.replace('m', ''), 2) * 60 * 1000;
      } else {
        time = parseInt(timeout, 2);
      }
    }

    if (current && time) {
      setTimeout(function () {
        return copyIntoState(undefined);
      }, time);
    }
  }, [current]);
  return [current, dispatchCopy];
};

var useDocumentTitle = function useDocumentTitle(title, backOnFinish) {
  var currentTitle = React.useRef(document.title);

  if (document && document.title && document.title.toLowerCase() === title.toLowerCase()) {
    return;
  }

  React.useEffect(function () {
    if (!document) {
      return;
    }

    document.title = title;

    if (!backOnFinish) {
      if (currentTitle && currentTitle.current) {
        if (typeof currentTitle.current === 'string') {
          document.title = currentTitle.current;
        }
      }
    }
  }, []);
};

var useOnlineOrOfflineBrowser = function useOnlineOrOfflineBrowser(option) {
  var defaultOption = option || 'keep-latest';

  var _a = React.useState(option && defaultOption === 'use-offline-as-default' ? 'offline' : 'online'),
      currentStatus = _a[0],
      updateStatus = _a[1];

  var onOnline = React.useCallback(function () {
    return updateStatus('online');
  }, [updateStatus]);
  var onOffline = React.useCallback(function () {
    return updateStatus('offline');
  }, [updateStatus]);
  React.useEffect(function () {
    if (!window) {
      return;
    }

    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);

    if (!(defaultOption && defaultOption === 'ignore-backup')) {
      return;
    }

    return function () {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
    };
  }, []);
  return currentStatus;
};

var useScroll = function useScroll(_a) {
  var domElementID = _a.domElementID,
      dependencies = _a.dependencies,
      fallback = _a.fallback;
  var element = document.querySelector("#" + domElementID);

  var _b = React.useState(),
      hooks = _b[0],
      indicateHooks = _b[1];

  var _queryElRef = React.useRef(element);

  var _watchDependencies = React.useCallback(function () {
    if (dependencies) {
      if (typeof dependencies.length === 'number' && dependencies.length === 1) {
        var trigger = dependencies[0];

        if (typeof trigger === 'string' && ['onmount', 'onstart'].includes(trigger.toLowerCase())) {
          indicateHooks([]);
        }
      } else if (!Array.isArray(dependencies)) {
        indicateHooks([dependencies]);
      }
    } else {
      indicateHooks([element]);
    }
  }, [dependencies, indicateHooks]);

  React.useEffect(function () {
    _watchDependencies();
  }, []);
  React.useEffect(function () {
    if (element && (window === null || window === void 0 ? void 0 : window.scrollTo) && _queryElRef && _queryElRef.current) {
      window.scrollTo({
        left: 0,
        top: _queryElRef.current.offsetTop
      });
    } else if (fallback && typeof fallback === 'function') {
      fallback();
    } else {
      process.env.NODE_ENV !== 'production' && console.warn('Algo ocorreu durante a execução do trigger ' + 'do useScroll.O elemento ou sua referência precisam ' + 'de dados concretos porém algum deles recebeu valor ' + 'undefined.');
      process.env.NODE_ENV !== 'production' && console.warn('Mensagem acima disparada pois nenhuma função de "fallback" foi declarada.');
    }
  }, [hooks]);
};

var useWindowSize = function useWindowSize(_a) {
  var defaultValue = (_a === void 0 ? {} : _a).defaultValue;
  var isClient = typeof window !== 'undefined';

  var _getSize = React.useCallback(function () {
    if (!isClient) {
      if (defaultValue) {
        var _a = defaultValue.width,
            width = _a === void 0 ? 0 : _a,
            _b = defaultValue.height,
            height = _b === void 0 ? 0 : _b;
        return {
          width: width,
          height: height
        };
      }

      return {
        width: 0,
        height: 0
      };
    }

    return {
      width: window.innerWidth,
      height: window.innerHeight
    };
  }, [isClient, defaultValue, window]);

  var _b = React.useState(_getSize()),
      _windowSize = _b[0],
      _setWindowSize = _b[1];

  var _handleResize = React.useCallback(function () {
    _setWindowSize(_getSize());
  }, [_setWindowSize, _getSize]);

  React.useEffect(function () {
    if (!isClient) {
      return function () {};
    }

    window.addEventListener('resize', _handleResize);
    return function () {
      window.removeEventListener('resize', _handleResize);
    };
  }, []);
  return _windowSize;
};

var usePathname = function usePathname(_a) {
  var router = (_a === void 0 ? {} : _a).router;

  var _b = React.useState(''),
      pathname = _b[0],
      _updatePathname = _b[1];

  var _treatPathname = React.useCallback(function (slices) {
    var _path = '';
    slices.forEach(function (element, index) {
      if (index === 0) {
        _path += element;
      } else {
        _path += element.charAt(0).toUpperCase() + element.slice(1, element.length);
      }
    });
    return _path;
  }, []);

  React.useEffect(function () {
    if (router && router.pathname && router.pathname.length) {
      var pathname_1 = router.pathname;

      var _slices = pathname_1.substr(1, pathname_1.length).split('/');

      var _path = _treatPathname(_slices);

      _updatePathname(_path);
    } else if (window && window.location) {
      var _pathname = window.location.pathname.substr(0, 1);

      _updatePathname(_pathname);
    }
  }, [router]);
  return pathname;
};

var useLatest = function useLatest(value) {
  var ref = React.useRef(value);
  ref.current = value;
  return ref;
};

var usePrevious = function usePrevious(value, initialValue) {
  var ref = React.useRef(initialValue);
  React.useEffect(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
};

var useIsomorphicLayoutEffect = typeof document !== 'undefined' ? React.useLayoutEffect : React.useEffect;

export { dispatchNotification, useClickAway, useClipboard, useDocumentTitle, useIsomorphicLayoutEffect, useLatest, useOnlineOrOfflineBrowser, usePathname, usePrevious, useScroll, useWindowSize };
